module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/164.bb13daf2.png";